var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  Janaka\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }